var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { DataGridRowActionsCell } from './data-grid-row-actions-cell';
import { DataGridCell } from './data-grid-cell';
var cls = classNames('data-grid-foot');
export var DataGridFootDefaultProps = {
  actions: ['add'],
  colors: {
    text: 'strong-chrome',
    background: 'canvas',
    hover: {
      background: 'very-subtle-chrome',
      text: 'text-chrome'
    }
  }
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-size: ", ";\n    ", "\n  "], ["\n    font-size: ", ";\n    ", "\n  "])), theme.FONT_SIZE(12), function (_a) {
    var canClick = _a.canClick;
    return canClick && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      cursor: pointer;\n    "], ["\n      cursor: pointer;\n    "])));
  })
});
var CellStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", ";\n    z-index: 2;\n    position: sticky;\n    bottom: 0;\n  "], ["\n    ", ";\n    z-index: 2;\n    position: sticky;\n    bottom: 0;\n  "])), theme.APPLY_COLORS)
});
var ActionsCellStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", ";\n    right: 0;\n    z-index: 3; /* Ensure it stays above other cells */    \n  "], ["\n    ", ";\n    right: 0;\n    z-index: 3; /* Ensure it stays above other cells */    \n  "])), CellStyles)
});
// -------- Components -------->
var My = {
  NAME: 'DataGridFoot',
  Container: styled.tr(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Cell: styled(DataGridCell)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), CellStyles),
  ActionsCell: styled(DataGridRowActionsCell)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ActionsCellStyles)
};
export var DataGridFoot = function (props) {
  var componentProps = useComponentProps(My.NAME, DataGridFootDefaultProps, props);
  var className = componentProps.className,
    children = componentProps.children,
    colors = componentProps.colors,
    onClick = componentProps.onClick,
    colSpan = componentProps.colSpan,
    actions = componentProps.actions,
    onButtonAction = componentProps.onButtonAction;
  return React.createElement(My.Container, {
    canClick: !!onClick,
    onClick: onClick,
    colors: colors,
    className: cls.name(className)
  }, React.createElement(My.Cell, {
    hasTopBorder: true,
    isLast: true,
    colors: colors,
    showActions: false,
    colSpan: colSpan
  }, children), React.createElement(My.ActionsCell, {
    hasTopBorder: true,
    hasLeftBorder: true,
    onButtonAction: onButtonAction,
    actions: actions
  }));
};
DataGridFoot.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;